export const CONFIG = {
    default_locale: "en",
    app_title: "Operation Santa Claus",
    app_title_cht: "愛心聖誕大行動",
    app_desc: "Jointly organised by the South China Morning Post and Radio Television Hong Kong, Operation Santa Claus (OSC) supports charities and shares the gift of hope and goodwill with those who lack the means to improve their lives.",
    app_desc_cht: "「愛心聖誕大行動」由南華早報及香港電台合辦，自1988年舉辦以來，推動社會各界參與善舉，傳揚聖誕真義，扶助貧困及弱勢人士。",
    telephone: "2680 8159",
    fasimile: "2680 8158",
    email: "osc@scmp.com",
    postal_address: "19/F, Tower 1, Times Square, 1 Matheson St., Causeway Bay, Hong Kong",
    postal_address_cht: "香港銅鑼灣勿地臣街1號時代廣場1座19樓",
    lazyload: {
        error: "/images/spacer.png",
        loading: "/images/ajax-loader.gif",
        banner: "/images/loading_banner.png",
        banner_mobile: "/images/loading_banner_mobile.png",
        // grid: "/images/loading_grid.png",
        // slide: "/images/loading_banner_mobile.png",
        grid: "data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAACCAQAAAA3fa6RAAAAEElEQVR42mN8+p8BCBghFAAiEQPLD3901QAAAABJRU5ErkJggg==",
        slide: "data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAACCAQAAAA3fa6RAAAAEElEQVR42mN8+p8BCBghFAAiEQPLD3901QAAAABJRU5ErkJggg==",
        report: "/images/loading_report.png",
    },
    breakpoints: {
        main: 768,
        sidemenu: 992
    }
};